module.exports = __webpack_public_path__ + "e990edb87eabb67044753183a9742b20.svg";